import { Model } from '@/clients/http'
import { createResourceApi, type ListQuery, type ListResult } from '@/http/models/Resource'

type Status = 'active' | 'inactive'

export interface Supplier {
  _id: string
  name: string
  contact_person?: string
  email?: string
  contact_number?: string
  address?: string
  status: Status
}

export interface MeasurementUnit {
  _id: string
  title: string
  description?: string
  status: Status
}

export interface PriceBook {
  _id: string
  title: string
  description?: string
  status: Status
}

export interface MembershipTier {
  _id: string
  name: string
  min_points: number
  discount_percentage: number
  status: Status
}

export const SupplierModel = createResourceApi<Supplier>('/api/backoffice/supplier', 'SUPPLIER')
export const MeasurementUnitModel = createResourceApi<MeasurementUnit>('/api/backoffice/measurement-unit', 'MEASUREMENT_UNIT')
export const PriceBookModel = createResourceApi<PriceBook>('/api/backoffice/price-book', 'PRICE_BOOK')
export const MembershipTierModel = createResourceApi<MembershipTier>('/api/backoffice/membership-tier', 'MEMBERSHIP_TIER')

export interface BookPriceRow {
  _id: string
  product_name: string
  name?: string
  sku: string
  regular_price: number
  book_price: number | null
}

export const BookPriceModel = {
  getList: (bookId: string, query: ListQuery) =>
    Model.createHttpRequest<ListResult<BookPriceRow>, { message?: string }>({
      correlationKey: 'GET_BOOK_PRICES',
      payload: { method: 'get', url: Model.createEndpoint({ url: '/api/backoffice/price-book/:id/prices', params: { id: bookId }, query }), useBearerToken: true },
    }),
  save: (bookId: string, body: { branch_id: string; prices: { product_variation_id: string; sale_price: number }[] }) =>
    Model.createHttpRequest<unknown, { message?: string }>({
      correlationKey: 'SAVE_BOOK_PRICES',
      payload: { method: 'put', url: Model.createEndpoint({ url: '/api/backoffice/price-book/:id/prices', params: { id: bookId } }), body, useBearerToken: true },
    }),
}
